import * as Types from '../constants/Types';

export const getListPointChangeHistory = (params) => ({ type: Types.POINT_CHANGE_HISTORY_GET_LIST_ACTION, params });
export const setListPointChangeHistory = (data) => ({ type: Types.POINT_CHANGE_HISTORY_GET_LIST_SUCCESS, ...(data || {}) });